import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
  },

  lightboxWrapper: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 100,
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    opacity: 1,
    animation: '.3s ease',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
  },

  lightboxContainer: {
    // position: 'absolute',
    // top: 0,
    // right: 0,
    // bottom: 0,
    // left: 0,
    flex: 1,
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  labelStudio: {
    flex: 1,

    // lsf-menu has the same z-index as our Modal (orobix-fe-components zIndexModal: 100),
    // so it ends up rendered on top of modal dialogs (e.g. the app info card). Resetting it
    // to the initial value (auto) keeps it within the annotator's stacking order.
    '& .lsf-menu': {
      zIndex: 'unset',
    },
  },

  doNotShowAgainCheckbox: {
    fontStyle: 'italic',
    fontSize: '0.8rem',
  },

  iconIsFading: {
    color: '#bc31a2',
  },

  readonlyBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    backgroundColor: '#fff3cd',
    color: '#856404',
    borderBottom: '1px solid #ffc107',
    fontSize: '0.875rem',
  },
})

export default useStyles
